module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ls8oN"))).then(() => parcelRequire('ljYL6'));